import React from 'react';
import { message, Space, Card, Button } from 'antd';

const text= "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua";

function Messages() {

  const [messageApi, contextHolder] = message.useMessage();

  const success = () => {
    messageApi.open({
      type: 'success',
      content: text,
    });
  };

  const error = () => {
    messageApi.open({
      type: 'error',
      content: text,
    });
  };

  const warning = () => {
    messageApi.open({
      type: 'warning',
      content: text,
    });
  };

  return (
    <Card title="Messages">
      {contextHolder}
      <Space>
        <Button onClick={success}>Success</Button>
        <Button onClick={error}>Error</Button>
        <Button onClick={warning}>Warning</Button>
      </Space>
    </Card>
  )
}

export default Messages;
